import { apiGet, apiPost, apiPut, apiPatch, apiDelete } from '@/app/api/core/http';
import { STANDING_REPORTS_PATHS } from './paths';

const { standingReports, suffix } = STANDING_REPORTS_PATHS;

export const standingReportsApiAdapter = {
  standingReports: {
    cleanAllProducts: (id) => apiPost(`${standingReports}/${id}/sections/clean`),
    cleanSectionProducts: ({ id, sectionId }) => apiPost(`${standingReports}/${id}/sections/${sectionId}/clean`),
  },
  postStandingReport: (data) => apiPost(standingReports + suffix, { data }),
  patchStandingReport: (id, data) => apiPatch(`${standingReports}/${id}`, { data, is_protected: true }),
  getStandingReports: (params, cat, headers) => {
    const { clearParams, ...rest } = params;
    let preparedParams = {
      params: rest,
      clearParams,
      is_protected: true,
    };
    if (headers) {
      preparedParams.headers = headers.headers;
    }
    return apiGet(standingReports + suffix, preparedParams);
  },
  getStandingReport: (id, headers) => {
    if (headers) {
      return apiGet(`${standingReports}/${id}`, {
        headers: headers,
      });
    } else {
      return apiGet(`${standingReports}/${id}`);
    }
  },
  postStandingReportSection: (id, data) => apiPost(`${standingReports}/${id}/sections`, { data }),
  deleteStandingReportSection: ({ id, sectionId }) => apiDelete(`${standingReports}/${id}/sections/${sectionId}`),
  putStandingReportSection: ({ id, sectionId, data }) =>
    apiPut(`${standingReports}/${id}/sections/${sectionId}`, { data }),
  addProductsToStandingReportSection: ({ id, sectionId, data }) =>
    apiPut(`${standingReports}/${id}/sections/${sectionId}/add`, {
      data,
    }),
  cloneStandingReport: (id) => apiPost(`${standingReports}/${id}/clone`),
  generateStandingReport: (id, data) => apiPost(`${standingReports}/${id}/generate`, { data }),
  deleteStandingReport: (id) => apiDelete(`${standingReports}/${id}`),
  deleteStandingReportProduct: ({ id, sectionId, data }) =>
    apiPut(`${standingReports}/${id}/sections/${sectionId}/delete`, {
      data,
    }),
};
